function dummyChatButtonIframe() {
  var iframe = document.getElementById("dummy-chat-button-iframe");
  var elmnt  = iframe.contentWindow.document.getElementById("dummy-chat-button");
  elmnt.click(); 
}

function ShopifyChat() { 
  var iframe = document.getElementById("ShopifyChat");
  var elmnt = iframe.contentWindow.document.getElementsByClassName("chat-toggle")[0];
  elmnt.click();
}

function initCSPage() {
  const dropdowns = document.querySelectorAll('.cs-details');
  let hash = window.location.hash ? window.location.hash.substring(1) : '';

  if (hash !== '') {
    closeAllDropdowns();
    const dropdown = document.querySelector(`#Details-${hash}`);
    if (dropdown) {
      openDropdown(dropdown);
    }
  }

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.contentRect.height > wrapperSize) {
        wrapperSize = entry.contentRect.height;
      }
    });
    document.documentElement.style.setProperty('--cs-min-height', `${Math.ceil(wrapperSize)}px`);
  });
  let wrapperSize = 0;

  dropdowns.forEach((dropdown) => {
    dropdown.querySelector('.cs-summary').addEventListener('click', (event) => {
      var hash = event.currentTarget.closest('.cs-details').dataset.hash;

      if (hash === 'track-order') {
        event.preventDefault();
        if (document.getElementById("dummy-chat-button-iframe")) {
          document.getElementById("dummy-chat-button-iframe").contentWindow.document.getElementById("dummy-chat-button").addEventListener("click", dummyChatButtonIframe(), true);
        } else {
          document.getElementById("ShopifyChat").contentWindow.document.getElementsByClassName("chat-toggle")[0].addEventListener("click", ShopifyChat(), true);
        }

        return;
      }
      
      window.location.hash = hash;
      if (window.innerWidth >= 1200) {
        closeAllDropdowns();
      }
    });

    resizeObserver.observe(dropdown.querySelector('.cs-content-wrapper'));
  });

  window.addEventListener('resize', () => {
    const openDropdowns = document.querySelectorAll(`.cs-details[open]:not([data-hash="${hash}"])`);
    if (window.innerWidth >= 1200 && openDropdowns) {
      openDropdowns.forEach((dropdown) => {
        closeDropdown(dropdown);
      });
    }
  });

  window.addEventListener('hashchange', () => {
    hash = window.location.hash ? window.location.hash.substring(1) : '';
    const dropdown = document.querySelector(`#Details-${hash}`);
    if (dropdown && !dropdown.hasAttribute('open')) {
      dropdown.querySelector('.cs-summary').click();
    }
  });

  function openDropdown(dropdown) {
    dropdown.setAttribute('open', '');
    dropdown.querySelector('.cs-summary').setAttribute('aria-expanded', true);
  }

  function closeDropdown(dropdown) {
    dropdown.removeAttribute('open');
    dropdown.querySelector('.cs-summary').setAttribute('aria-expanded', false);
  }

  function closeAllDropdowns() {
    dropdowns.forEach((e) => {
      closeDropdown(e);
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initCSPage();
});

document.addEventListener('shopify:section:load', function() {
  initCSPage();
});
